import {matchPath} from 'react-router-dom';

// Route patterns flagged `supportsOffline` in the route registry, kept here so
// the app tier (sidebar) can ask without importing the pages tier.
const offlineRoutePatterns = new Set<string>();

export const registerOfflineRoute = (pattern: string): void => {
  offlineRoutePatterns.add(pattern);
};

export const isOfflineRoute = (pathname: string): boolean =>
  [...offlineRoutePatterns].some(
    pattern => matchPath(pattern, pathname) !== null
  );

export const resetOfflineRoutes = (): void => {
  offlineRoutePatterns.clear();
};
